module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-227.442531d2.svg";